const initializeMimoPredictiveSearch = () => {
  const drawer = document.querySelector('[data-search-drawer]');
  const input = drawer?.querySelector('[data-search-input]');
  const results = drawer?.querySelector('[data-search-results]');
  const status = drawer?.querySelector('[data-search-status]');
  const toggles = document.querySelectorAll('[data-search-toggle]');
  if (!drawer || !input || !results || !status || !toggles.length) return;

  if (drawer.parentElement !== document.body) document.body.appendChild(drawer);

  let debounceTimer;
  let requestController;
  let previousFocus;

  const setExpanded = (expanded) => {
    input.setAttribute('aria-expanded', String(expanded));
    toggles.forEach((toggle) => toggle.setAttribute('aria-expanded', String(expanded)));
  };

  const openSearch = () => {
    document.querySelector('[data-menu].is-open [data-drawer-close]')?.click();
    document.querySelector('[data-cart-drawer].is-open [data-drawer-close]')?.click();
    previousFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('no-scroll');
    setExpanded(Boolean(results.children.length));
    window.setTimeout(() => input.focus(), 120);
  };

  const closeSearch = () => {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('no-scroll');
    setExpanded(false);
    if (previousFocus instanceof HTMLElement) previousFocus.focus();
  };

  const renderResults = async () => {
    const term = input.value.trim();
    requestController?.abort();
    if (term.length < 2) {
      results.replaceChildren();
      status.textContent = '';
      input.setAttribute('aria-expanded', 'false');
      return;
    }

    requestController = new AbortController();
    status.textContent = drawer.dataset.searchLoading;
    const endpoint = new URL(drawer.dataset.predictiveSearchUrl, window.location.origin);
    endpoint.searchParams.set('q', term);
    endpoint.searchParams.set('resources[type]', 'product');
    endpoint.searchParams.set('resources[limit]', '6');
    endpoint.searchParams.set('resources[options][unavailable_products]', 'hide');
    endpoint.searchParams.set('section_id', 'predictive-search');

    try {
      const response = await fetch(endpoint, { signal: requestController.signal, headers: { 'X-Requested-With': 'XMLHttpRequest' } });
      if (!response.ok) throw new Error('Search request failed');
      const documentFragment = new DOMParser().parseFromString(await response.text(), 'text/html');
      const content = documentFragment.querySelector('[data-predictive-search-content]');
      results.replaceChildren();
      if (content) results.appendChild(document.importNode(content, true));
      input.setAttribute('aria-expanded', 'true');
      status.textContent = content ? drawer.dataset.searchUpdated : drawer.dataset.searchEmpty;
    } catch (error) {
      if (error.name !== 'AbortError') {
        results.replaceChildren();
        input.setAttribute('aria-expanded', 'false');
        status.textContent = drawer.dataset.searchError;
      }
    }
  };

  toggles.forEach((toggle) => toggle.addEventListener('click', openSearch));
  drawer.querySelectorAll('[data-search-close]').forEach((control) => control.addEventListener('click', closeSearch));
  input.addEventListener('input', () => {
    window.clearTimeout(debounceTimer);
    debounceTimer = window.setTimeout(renderResults, 180);
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && drawer.classList.contains('is-open')) closeSearch();
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeMimoPredictiveSearch, { once: true });
} else {
  initializeMimoPredictiveSearch();
}
